import { useEffect } from "react";

import { partnerService } from "../../services/partnerService";

export function useInitPartner() {
  useEffect(() => {
    const existingPartner = partnerService.getPartner();
    if (!existingPartner) {
      console.log("Initializing partner from useInitPartner");
      partnerService.initPartner(window.location);
    }
  }, [window.location]);
}
